"use client";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useI18n } from "@/locales/client";
import { motion } from "framer-motion";
import { Metadata } from "next";
import Link from "next/link";
import { SocialIcon } from "react-social-icons";
export const metadata: Metadata = {
  title: "Suri Bass Music Official Website | About",
  description: "Suri Bass Music Official Website",
};
export function AboutPage() {
  const t = useI18n();
  const cardVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1 },
  };
  const socialMediaLinks = [
    {
      name: "facebook",
      url: "https://www.facebook.com/profile.php?id=100009166781443",
    },
    {
      name: "soundcloud",
      url: "https://soundcloud.com/mickael-amimba-437676768",
    },
    {name: "youtube", 
      url: "https://www.youtube.com/@DJLYONKING"},
    {
      name: "tiktok",
      url: "https://www.tiktok.com/@dj.lyon.king",
    },
  ];
  return (
    <div className="container mx-auto py-8 px-4">
      <motion.h1
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-5xl font-extrabold text-center mb-8 "
      >
        {t("about_page.about_title")}
      </motion.h1>

      <motion.div
        initial="hidden"
        animate="visible"
        variants={{ visible: { transition: { staggerChildren: 0.2 } } }}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center mb-12">
          <motion.div variants={cardVariants}>
            <Card className="shadow-xl ">
              <CardContent className="p-6">
                <div className="flex justify-center">
                  <motion.img
                    variants={cardVariants}
                    src="/logo/icon_256x256.png"
                    alt="DJ Lyon King"
                    className="w-48 h-48 rounded-full shadow-xl bg-muted"
                  />
                  
                </div>
                <motion.div className="mt-6 text-center">
                  <h2 className="text-3xl font-bold mb-4">
                    {t("about_page.who_we_are")}
                  </h2>
                  <p>{t("about_page.who_we_are_description")}</p>
                </motion.div>
              </CardContent>
            </Card>
          </motion.div>

          <motion.div
            variants={cardVariants}
            className="md:text-left text-center"
          >
            <h2 className="text-3xl font-bold mb-4">
              {t("about_page.our_mission")}
            </h2>
            <p className="text-lg">{t("about_page.our_mission_description")}</p>
            <Link href="https://discord.gg/5uVFD9dR" target="_blank">
            <Button className="mt-6 text-lg">{t("about_page.join_us")}
            </Button>
            </Link>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {["what_we_offer", "sharing_and_collaboration", "join_us"].map(
            (key) => (
              <motion.div
                key={key}
                variants={cardVariants}
                className="text-center p-6  bg-muted rounded-lg shadow-lg"
              >
                <h2 className="text-2xl font-bold mb-4">
                  {/* @ts-ignore */}
                  {t(`about_page.${key}`)}
                </h2>
                <p className="text-gray-600 dark:text-gray-300">
                  {/* @ts-ignore */}
                  {t(`about_page.${key}_description`)}
                </p>
              </motion.div>
            )
          )}
        </div>

        <motion.div variants={cardVariants} className="mt-12 text-center">
          <h2 className="text-3xl font-bold mb-4">
            {t("about_page.contact_us")}
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-300">
            {t("about_page.contact_us_description")}{" "}
            <Link
              className="text-primary font-semibold hover:underline"
              href={"/contact"}
            >
              {t("about_page.here")}
            </Link>
            .
          </p>
        </motion.div>

        <motion.div
          variants={cardVariants}
          className="mt-6 flex justify-center"
        >
          <div className="flex space-x-6">
            {socialMediaLinks.map((link, key) => (
            
                <SocialIcon key={key} network={link.name} url={link.url} />
            ))}
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
}
